export default __webpack_public_path__ + "static/media/media-residential-5.b3f769f3.jpg";